import React from 'react';
import classnames from 'classnames';
import { viaFill as defaultOptions } from 'shared/data/selectOptions';
import { viaFill } from 'shared/data/tooltips';
import SelectComponent from 'shared/components/SelectComponent';

const ViaFill = (props) => {
  const name = 'via_fill';
  const {
    options,
    parameters,
    onChangeParameter,
    groupName,
    className,
    label,
    required,
    tooltip,
  } = props;

  const onChange = e => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('material-thickness', className)} />
  );
};

ViaFill.defaultProps = {
  options: defaultOptions,
  label: 'Filled Vias',
  tooltip: viaFill,
};

export default ViaFill;
